import { useState } from "react";
import Circle from "../Circle/Circle.jsx";
import MainBtn from "../MainBtn/MainBtn.jsx";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@material-ui/core";
import useStyles from "./styles.js";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Questions = () => {
  const mobile = useMediaQuery("(max-width:768px)");

  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const settings = {
    circle: "rightCircle",
    btnSettings: {
      variant: "outlined",
      color: "primary",
      text: "Mandar un mensaje",
    },
  };

  return (
    <Box component="div" className={classes.questionsContainer}>
      <Circle circleClass={settings.circle} />
      <Box component="div" className={classes.greenCircle}></Box>
      <Box component="div" className={classes.blueCircle}></Box>
      <Box
        component="div"
        className={!mobile ? classes.content : classes.contentMob}
      >
        <Typography variant="h2" color="secondary" className={classes.title}>
          Preguntas Frecuentes
        </Typography>
        <Box component="div" className={classes.questions}>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            className={mobile ? classes.accordionGap : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
            >
              <Typography
                variant="body1"
                color="primary"
                className={classes.eachQuestion}
              >
                ¿Cómo puedo pagar el traslado?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography p="true" className={classes.answer}>
                Nulla facilisi. Phasellus sollicitudin nulla et quam mattis
                feugiat. Aliquam eget maximus est, id dignissim quam.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            className={mobile ? classes.accordionGap : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
            >
              <Typography
                variant="body1"
                color="primary"
                className={classes.eachQuestion}
              >
                ¿El servicio es seguro?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography p="true" className={classes.answer}>
                Donec placerat, lectus sed mattis semper, neque lectus feugiat
                lectus, varius pulvinar diam eros in elit. Pellentesque
                convallis laoreet laoreet.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            className={mobile ? classes.accordionGap : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
            >
              <Typography
                variant="body1"
                color="primary"
                className={classes.eachQuestion}
              >
                ¿Puedo cancelar un servicio?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography p="true" className={classes.answer}>
                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.
                Integer sit amet egestas eros, vitae egestas augue. Duis vel est
                augue.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel4"}
            onChange={handleChange("panel4")}
            className={mobile ? classes.accordionGap : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
            >
              <Typography
                variant="body1"
                color="primary"
                className={classes.eachQuestion}
              >
                ¿Si me olvido algo dentro del auto?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography p="true" className={classes.answer}>
                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.
                Integer sit amet egestas eros, vitae egestas augue. Duis vel est
                augue.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel5"}
            onChange={handleChange("panel5")}
            className={mobile ? classes.accordionGap : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
            >
              <Typography
                variant="body1"
                color="primary"
                className={classes.eachQuestion}
              >
                ¿Cómo puedo establecer un precio si no conozco esta ruta?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography p="true" className={classes.answer}>
                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.
                Integer sit amet egestas eros, vitae egestas augue. Duis vel est
                augue.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel6"}
            onChange={handleChange("panel6")}
            className={mobile ? classes.accordionGap : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
            >
              <Typography
                variant="body1"
                color="primary"
                className={classes.eachQuestion}
              >
                ¿Qué es una calificación de Conductor?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography p="true" className={classes.answer}>
                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.
                Integer sit amet egestas eros, vitae egestas augue. Duis vel est
                augue.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel7"}
            onChange={handleChange("panel7")}
            className={mobile ? classes.accordionGap : ""}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
            >
              <Typography
                variant="body1"
                color="primary"
                className={classes.eachQuestion}
              >
                ¿Qué es una calificación de Usuario?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography p="true" className={classes.answer}>
                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl.
                Integer sit amet egestas eros, vitae egestas augue. Duis vel est
                augue.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box
          component="div"
          className={!mobile ? classes.message : classes.messageMob}
        >
          <Typography
            variant="h3"
            className={!mobile ? classes.help : classes.helpMob}
          >
            ¿Aún con dudas?
            <br /> Déjanos ayudarte.
          </Typography>
          <MainBtn btn={settings.btnSettings} />
        </Box>
      </Box>
    </Box>
  );
};

export default Questions;
